import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@components/Input';
import ComboLocationSelect from '@features/ComboLocationSelect';
import { Switch } from '@components/Switch';
import { useTranslation, useLocations } from '@hooks';

const PrimaryFields = ({ isView, selectedCoupon, brands }) => {
    const { control, getValues, setValue } = useFormContext();
    const { t } = useTranslation();
    const { getSelectLocationsOptions } = useLocations();

    const brandsOptions = useMemo(() => brands.map(item => ({ value: item.id, label: item.title })), [brands]);

    const locationsOptions = useMemo(() => getSelectLocationsOptions(), []);

    return (
        <>
            <Controller
                control={control}
                name="title"
                render={({ field, fieldState: { error }, ref }) => (
                    <Input
                        ref={ref}
                        inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                        label={t('common.title')}
                        fullWidth
                        error={!!error}
                        helperText={error ? t(error.message) : null}
                        required
                        disabled={isView}
                    />
                )}
            />
            <ComboLocationSelect
                brandsOptions={brandsOptions}
                locationsOptions={locationsOptions}
                data={selectedCoupon}
                disabled={isView}
                isView={isView}
            />
            <Controller
                control={control}
                name="status"
                render={({ field, ref }) => (
                    <Switch
                        {...field}
                        ref={ref}
                        checked={getValues('status')}
                        handleChange={event => {
                            setValue('status', event.target.checked, { shouldDirty: true });
                        }}
                        label={t('CouponsPage.activateCoupon')}
                        disabled={isView}
                        sx={{ marginTop: '-16px' }}
                    />
                )}
            />
        </>
    );
};

export default PrimaryFields;
